import _ from 'lodash';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

const selectClaims = ({ claims }) => claims;

export const selectGroupedClaims = createSelector(selectClaims, claims =>
  _.groupBy(
    claims?.map(({ value }) => value),
    claim => claim?.split('.').slice(0, -1).join('.'),
  ),
);

const selectGroupClaimNames = createSelector(selectGroupedClaims, groupedClaims =>
  Object.keys(groupedClaims).filter(Boolean),
);

const selectSortedGroupClaimNames = createSelector(selectGroupClaimNames, groupClaimNames =>
  _.sortBy(groupClaimNames, [name => _.toLower(name)]),
);

export const selectFilteredGroupClaimNames = createSelector(
  getDebouncedSearchValue,
  selectSortedGroupClaimNames,
  selectGroupedClaims,
  (searchValue, groupNames, groupedClaims) =>
    searchItems(name => [name, ...(groupedClaims[name] ?? [])])(searchValue, groupNames),
);
